import React, { useState } from 'react';
import PropTypes, { any } from 'prop-types';

import styles from './courtSchedular.scss';
import { CheckBox } from '../../../components/Form';

const DrawFilterOption = (props) => {
    const {
        filterName,
        filterKey,
        className,
        filterOptions,
        selectedFilters,
        setSelectedFilters,
    } = props;

    const [isFilterDropDownOpen, setIsFilterDropDownOpen] = useState(false);

    const onClickItem = () => {
        setIsFilterDropDownOpen(!isFilterDropDownOpen);
    };

    const onFilterOptionChecked = (option) => (checked) => {
        const selectedFiltersWithoutOption = selectedFilters.filter((filter) => {
            return !(filter.type === filterKey && filter.id === option.id);
        });

        if (checked) {
            setSelectedFilters([
                ...selectedFiltersWithoutOption,
                {
                    id: option.id,
                    type: filterKey,
                    label: option.label,
                },
            ]);
        } else {
           // Remove from list
           setSelectedFilters(selectedFiltersWithoutOption);
        }
    };

    const isOptionSelected = (option) => {
        return selectedFilters.find((filter) => {
            return filter.type === filterKey && filter.id === option.id;
        });
    };

    return (
        <div className={`${className} ${styles.filter}`}>
            <div
                className={`d-flex align-items-center ${styles.clickable}`}
                onClick={onClickItem}
                data-testid={`court-scheduler.filter-option.${filterKey}`}
            >
                <div className={styles.arrow}>
                    {isFilterDropDownOpen && (
                        <i className={`fas fa-solid fa-caret-down`} />
                    )}
                    {!isFilterDropDownOpen && (
                        <i className={`fas fa-solid fa-caret-right`} />
                    )}
                </div>
                <div className="flex-1 mw0 ml4 mr4 ellipsis" data-testid={`court-scheduler.filter-option.${filterKey}.label`}>
                    {filterName}
                </div>
            </div>
            {isFilterDropDownOpen && filterOptions.length > 0 && filterOptions.map((option) => {
                return (
                    <CheckBox
                        key={`option-${filterKey}-${option.id}`}
                        controlled={true}
                        id={`${filterKey}-${option.id}`}
                        customLabel={option.label}
                        formGroupCssClass={styles.checkbox}
                        checked={isOptionSelected(option)}
                        onChange={onFilterOptionChecked(option)}
                        data-testid="court-scheduler.item-item-checkbox"
                    />
                );
            })}
        </div>
    );
};

DrawFilterOption.propTypes = {
    className: PropTypes.string,
    filterName: PropTypes.string.isRequired,
    filterKey: PropTypes.string.isRequired,
    filterOptions: PropTypes.arrayOf(any).isRequired,
    selectedFilters: PropTypes.arrayOf(any),
    setSelectedFilters: PropTypes.func.isRequired,
};

DrawFilterOption.defaultProps = {
    className: null,
    selectedFilters: [],
};

export default DrawFilterOption;
